export default () => ({
  channelData: {},
});
